import { useEffect, useRef, useState } from 'react';
import styles from './Home.module.scss';
import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Controller, EffectFade } from 'swiper';
import { OPERATOR, DRIVER, LAB, FILLER, stories } from '@/src/constants';
import { createText } from '@/src/utils/createText';
import { Footer } from '@/src/components/Footer';
import { CSSTransition } from 'react-transition-group';
import 'swiper/css/effect-fade';
import sendEventToCounters from '@/src/counterEvents';

import top from '../../images/top-people.png';
import topMob from '../../images/top-people-mob.png';
import bottom from '../../images/bottom.png';
import bottomMob from '../../images/bottom-mob.png';

type TProps = {
  changePage: (pageName: string) => void;
};

export const Home = ({ changePage }: TProps) => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    });
  }, []);

  const [isAnimated, setIsAnimated] = useState(false);

  let timerId: ReturnType<typeof setTimeout>;

  useEffect(() => {
    timerId = setTimeout(() => {
      setIsAnimated(true);
    }, 1);

    return () => clearTimeout(timerId);
  }, []);

  const sliderBlockRef = useRef<HTMLDivElement>(null);

  const handleGoStart = () => {
    changePage('start');
    sendAnalytics('history');
  };

  const [isAnimatedScroll, setIsAnimatedScroll] = useState(false);

  const handleScroll = () => {
    if (document.body.clientWidth >= 1340 && window.scrollY > 1200) {
      setIsAnimatedScroll(true);
    } else if (
      document.documentElement.clientWidth > 2000 &&
      window.scrollY > 600
    ) {
      setIsAnimatedScroll(true);
    } else if (
      document.documentElement.clientWidth < 1340 &&
      document.documentElement.clientWidth >= 700 &&
      window.scrollY > 800
    ) {
      setIsAnimatedScroll(true);
    } else if (
      document.documentElement.clientWidth < 700 &&
      window.scrollY > 300
    ) {
      setIsAnimatedScroll(true);
    }
  };

  const [showHiddenSlides, setShowHiddenSlides] = useState<string[]>([]);

  const handleShowHidden = (slide: string) => {
    const newSlides = [...showHiddenSlides];
    if (newSlides.includes(slide)) {
      newSlides.splice(newSlides.indexOf(slide), 1);
    } else {
      newSlides.push(slide);
      if (document.documentElement.clientWidth <= 1020) {
        switch (slide) {
          case OPERATOR:
            sendAnalytics('kassir_azs');
            break;
          case DRIVER:
            sendAnalytics('voditel');
            break;
          case LAB:
            sendAnalytics('laborant');
            break;
          case FILLER:
            sendAnalytics('napolnitel');
            break;
          default:
            break;
        }
      }
    }
    setShowHiddenSlides(newSlides);
  };

  const [hoverSlide, setHoverSlide] = useState<string>();

  useEffect(() => {
    switch (hoverSlide) {
      case OPERATOR:
        sendAnalytics('kassir_azs');
        break;
      case DRIVER:
        sendAnalytics('voditel');
        break;
      case LAB:
        sendAnalytics('laborant');
        break;
      case FILLER:
        sendAnalytics('napolnitel');
        break;
      default:
        break;
    }
  }, [hoverSlide]);

  const handleGoGame = () => {
    changePage('start');
    sendAnalytics('start');
  };

  const sendAnalytics = (label: string) => {
    sendEventToCounters({ action: 'landing', label });
  };

  const [mainSwiper, setMainSwiper] = useState<any>({});
  const [thumbsSwiper, setThumbsSwiper] = useState<any>({});

  const renderThumbsSlides = () => {
    return Object.keys(stories).map((slide: string) => {
      return (
        <SwiperSlide key={stories[slide].id}>
          <div
            className={classNames(styles.slide, styles[stories[slide].id], {
              [styles.slideShowHidden]: showHiddenSlides.includes(
                stories[slide].id,
              ),
            })}
          >
            <div className={styles.slideTitle}>{stories[slide].title}</div>
            <div className={styles.slideText}>
              {stories[slide].homeSlideText.map(
                (text: string, index: number) => (
                  <p key={index} dangerouslySetInnerHTML={createText(text)}></p>
                ),
              )}
            </div>
            <div
              className={styles.slideHidden}
              onClick={() => handleShowHidden(stories[slide].id)}
            >
              <div>
                <div className={styles.slideHiddenTitle}>
                  Что я&#160;ценю в&#160;компании «Газпром&#160;нефть»:
                </div>
                <div className={styles.slideHiddenList}>
                  {stories[slide].homeSlideHidden.map(
                    (item: { icon: string; text: string }, index: number) => (
                      <div key={index} className={styles.slideHiddenItem}>
                        <div className={styles.slideHiddenIcon}>
                          <img src={item.icon} alt="" />
                        </div>
                        <p dangerouslySetInnerHTML={createText(item.text)}></p>
                      </div>
                    ),
                  )}
                </div>
              </div>
              <a
                href={getLink(slide)}
                target="_blank"
                rel="noreferrer"
                className={styles.vacanciesButton}
                onClick={() => handleGoToVacancies(slide)}
              >
                Вакансии
              </a>
            </div>
          </div>
        </SwiperSlide>
      );
    });
  };

  const renderMainSlides = () => {
    return Object.keys(stories).map((slide: string) => {
      return (
        <SwiperSlide key={stories[slide].id}>
          <div
            className={classNames(
              styles.slide,
              styles[stories[slide].id],
              styles.active,
            )}
            onMouseOver={() => setHoverSlide(slide)}
          >
            <div className={styles.slideTitle}>{stories[slide].title}</div>
            <div className={styles.slideText}>
              {stories[slide].homeSlideText.map(
                (text: string, index: number) => (
                  <p key={index} dangerouslySetInnerHTML={createText(text)}></p>
                ),
              )}
            </div>
            <div
              className={styles.slideHidden}
              onClick={() => handleShowHidden(stories[slide].id)}
            >
              <div>
                <div className={styles.slideHiddenTitle}>
                  Что я&#160;ценю в&#160;компании «Газпром&#160;нефть»:
                </div>
                <div className={styles.slideHiddenList}>
                  {stories[slide].homeSlideHidden.map(
                    (item: { icon: string; text: string }, index: number) => (
                      <div key={index} className={styles.slideHiddenItem}>
                        <div className={styles.slideHiddenIcon}>
                          <img src={item.icon} alt="" />
                        </div>
                        <p dangerouslySetInnerHTML={createText(item.text)}></p>
                      </div>
                    ),
                  )}
                </div>
              </div>
              <a
                href={getLink(slide)}
                target="_blank"
                rel="noreferrer"
                className={styles.vacanciesButton}
                onClick={() => handleGoToVacancies(slide)}
              >
                Вакансии
              </a>
            </div>
          </div>
        </SwiperSlide>
      );
    });
  };

  const getLink = (slide: string) => {
    switch (slide) {
      case OPERATOR:
        return 'https://my.hh.ru/dA';
      case DRIVER:
        return 'https://my.hh.ru/h6';
      case LAB:
        return 'https://my.hh.ru/hN';
      case FILLER:
        return 'https://my.hh.ru/i0';
      default:
        break;
    }
  };

  const handleGoToVacancies = (slide: string) => {
    switch (slide) {
      case OPERATOR:
        sendAnalytics('tab-operator');
        break;
      case DRIVER:
        sendAnalytics('tab-voditel');
        break;
      case LAB:
        sendAnalytics('tab-laborant');
        break;
      case FILLER:
        sendAnalytics('tab-napolnitel');
        break;
      default:
        break;
    }
  };

  return (
    <div
      className={(styles.home, 'home')}
      onWheel={handleScroll}
      onTouchMove={handleScroll}
    >
      <div className={styles.top}>
        <div className="container">
          <div className={styles.topWrapper}>
            <CSSTransition in={isAnimated} timeout={200} classNames="fadeLeft">
              <div
                className={classNames(
                  styles.topText,
                  styles.textTop,
                  'fadeLeft',
                )}
              >
                Заправить машину&#160;– всего пара минут для&#160;автомобилиста.
              </div>
            </CSSTransition>
            <div className={styles.topImage}>
              <picture>
                <source media="(max-width: 700px)" srcSet={topMob} />
                <img src={top} alt="" />
              </picture>
            </div>
            <CSSTransition in={isAnimated} timeout={200} classNames="fadeRight">
              <div
                className={classNames(
                  styles.topText,
                  styles.textBottom,
                  'fadeRight',
                )}
              >
                Но чтобы это происходило быстро и&#160;легко, работают сотни
                людей на&#160;производственных объектах: АЗС и&#160;нефтебазах.
              </div>
            </CSSTransition>
            <div className={styles.topTitle}>
              Познакомьтесь с&#160;профессиями в&#160;«Газпром нефти»
            </div>
            <div className={styles.topContent}>
              <p className={styles.topContentDesk}>
                Узнайте больше о&#160;людях, которые помогают нам продолжать
                движение, путешествовать и&#160;вовремя приезжать
                на&#160;помощь. Их&#160;истории вдохновляют и&#160;показывают,
                как&#160;профессионализм и&#160;любовь к&#160;работе способны
                изменить мир вокруг&#160;нас.
              </p>
              <p className={styles.topContentMob}>
                Познакомьтесь с&#160;профессиями в&#160;«Газпром нефти»
                и&#160;узнайте больше о&#160;людях, которые помогают нам
                продолжать движение, путешествовать и&#160;вовремя приезжать
                на&#160;помощь. Их&#160;истории вдохновляют и&#160;показывают,
                как&#160;профессионализм и&#160;любовь к&#160;работе способны
                изменить мир вокруг&#160;нас.
              </p>
              <button
                className={classNames('button', styles.topButton)}
                onClick={handleGoStart}
              >
                Узнать историю!
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bg} ref={sliderBlockRef}>
        <div className="container">
          <div className={styles.slider_wrapper}>
            <div className={styles.main_slide}>
              <Swiper
                modules={[Controller, EffectFade]}
                onSwiper={setMainSwiper}
                controller={
                  thumbsSwiper ? { control: thumbsSwiper } : undefined
                }
                loop={true}
                loopAdditionalSlides={4}
                effect="fade"
                allowTouchMove={false}
              >
                {renderMainSlides()}
              </Swiper>
            </div>
            <div className={styles.thumbs}>
              <Swiper
                modules={[Controller, Navigation, Pagination]}
                onSwiper={setThumbsSwiper}
                controller={mainSwiper ? { control: mainSwiper } : undefined}
                slidesPerView={'auto'}
                spaceBetween={20}
                loop={true}
                loopAdditionalSlides={4}
                slideToClickedSlide
                allowTouchMove={true}
                speed={600}
                navigation={{
                  nextEl: '.sliderArrow--right',
                  prevEl: '.sliderArrow--left',
                }}
                pagination={{
                  el: '.sliderPagination',
                  bulletActiveClass: 'sliderBulletActive',
                  bulletClass: 'sliderBullet',
                  clickable: true,
                }}
                breakpoints={{
                  1020: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    allowTouchMove: false,
                    speed: 1000,
                  },
                }}
                onSlideChange={() => {
                  setShowHiddenSlides([]);
                }}
              >
                {renderThumbsSlides()}
              </Swiper>
            </div>
          </div>
          <div className={styles.sliderControls}>
            <div className="sliderPagination"></div>
            <div className={styles.sliderArrows}>
              <div className="sliderArrow sliderArrow--left"></div>
              <div className="sliderArrow sliderArrow--right"></div>
            </div>
          </div>
          <div className={classNames(styles.bottom, 'bottom')}>
            <CSSTransition
              in={isAnimatedScroll}
              timeout={200}
              classNames="fadeLeft"
            >
              <div
                className={classNames(
                  styles.bottomText,
                  styles.bottomTextWhite,
                  'fadeLeft',
                  'fadeLeftBottom',
                )}
              >
                Сотрудники «Газпром нефти»&#160;— обычные люди, которые делают
                простое, но&#160;важное и&#160;ответственное дело.
              </div>
            </CSSTransition>
            <CSSTransition
              in={isAnimatedScroll}
              timeout={200}
              classNames="fadeRight"
            >
              <div className={classNames(styles.bottomImage, 'fadeRight')}>
                <picture>
                  <source media="(max-width: 700px)" srcSet={bottomMob} />
                  <img src={bottom} alt="" />
                </picture>
              </div>
            </CSSTransition>
            <CSSTransition
              in={isAnimatedScroll}
              timeout={200}
              classNames={
                document.documentElement.clientWidth > 1020
                  ? 'fadeLeft'
                  : 'fadeRight'
              }
            >
              <div
                className={classNames(
                  styles.bottomText,
                  styles.bottomTextBlue,
                  document.documentElement.clientWidth > 1020
                    ? 'fadeLeft'
                    : 'fadeRight',
                )}
              >
                Иногда в&#160;работе с&#160;ними происходят необыкновенные
                события.
              </div>
            </CSSTransition>
            <div className={styles.bottomContent}>
              <p>
                Прочитайте истории и&#160;узнайте больше
                об&#160;их&#160;профессиях и&#160;жизни.
              </p>
              <button
                className={classNames('button', styles.bottomButton)}
                onClick={handleGoGame}
              >
                Начать
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
